import React from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { StyledEngineProvider } from '@mui/material/styles';


import { Country } from '../../types/Country';
import { getTermsByLang, getCountryNameByLang, getColorForRiskClass, getTranslatedRiskClassValue, getTranslatedValueForPolicy} from '../../utils/utils';

type Props = {
    data: Country;
    goBack: () => void;
}

const CountryData: React.FunctionComponent<Props> = (props: Props) => {
  const { t } = useTranslation();
  const countryData = props.data;
  const goBack = props.goBack;

  const renderRiskClassExplanation = () => {
    const value = getTranslatedRiskClassValue(countryData.riskClass);
    if (value) {
      return t(value);
    }
  }

  const renderPolicyExplanation = () => {
    const value = getTranslatedValueForPolicy(countryData.classFin);
    if (value) {
      return t(value);
    }
  }

  return (
    <div className="country-data">
      <div className="country-data-header">
        <label>
          <h6 className="heading-6">{getCountryNameByLang(countryData)}</h6>
        </label>
        <label className="country-data-back-button-label">
          <StyledEngineProvider injectFirst>
          <IconButton className="country-data-back-button" color="inherit" size="small" onClick={goBack}>
            <ArrowBackIosIcon/>
            {t('countryData:info.backButton')}
          </IconButton>
        </StyledEngineProvider>
        </label>
      </div>
      <div className="country-data-info-container">
        <div className="country-data-info-row">
          <div className="country-data-info-box">
            <label style={{fontWeight:"bold"}}>{t('countryData:info.contact')}</label>
            <div className="country-data-info-contact">
              <p>{countryData.countrySpecialist}</p>
              <p>{countryData.countrySpecialistPhone}</p>
              <p>{t('countryData:info.email')}</p>
            </div>
          </div>
          <div className="country-data-info-box">
            <label style={{fontWeight:"bold"}}>{t('countryData:info.geopolitics')}</label>
            <div className="country-data-info-risk-class">
              <span className="country-data-info-risk-class-value" style={{backgroundColor: getColorForRiskClass(countryData.riskClass)}}>
                {countryData.riskClass}
              </span>
              <label>{renderRiskClassExplanation()}</label>
            </div>
            <label style={{fontWeight:"bold"}}>{t('countryData:info.landClass')}</label>
            <div className="country-data-info-policy">
              <span className="country-data-info-policy-value" style={{backgroundColor:"#383838"}}>
                {countryData.classFin}
              </span>
              <label>{renderPolicyExplanation()}</label>
            </div>
          </div>
        </div>
        <div className="country-data-info-row">
          <div className="country-data-info-box">
            <label style={{fontWeight:"bold"}}> {t('countryData:info.condition')} </label>
            <div className="country-data-info-terms">
              <p>{getTermsByLang(countryData)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CountryData;
